export const toSentenceCase = (str: string) => {
    return str.trimStart().charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };